import * as React from "react";

export class ForOhFour extends React.Component<any, any>{
    render(){
        return <h4>404! oh noes</h4>;
    }
}


// WEBPACK FOOTER //
// ./src/components/ForOhFour.tsx